import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import HamburgerMenu from '../HamburgerMenu';
import React from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav
        className="sticky top-5 z-50 w-full  
          bg-[#e7e9e9]/30 backdrop-blur-md 
          border-2 border-gray-100 
          shadow-sm rounded-full 
          my-4 mx-auto max-w-7xl 
          px-4 py-4 flex items-center justify-between"
      >
        {/* Logo */}

        <div className='flex items-center'>
          <Link
            to="/"
            className="text-2xl px-2 font-poppins font-extrabold text-gray-900"
          >
            Bgremoverr.cloud
          </Link>
          <Link
            to="/text-behind-image"
            className="hover:text-[#242424] hidden md:block font-poppins font-bold text-[16px] ml-6"
          >
            Text-Behind-Image
          </Link>
        </div>

        <div className="md:hidden">
          <HamburgerMenu />
        </div>
        {/* Right Side Buttons */}
        <div className="hidden md:flex items-center space-x-3 text-sm">

          <Link
            to="/blog"
            className="bg-[#191A1F] font-poppins text-white text-[16px] px-4 py-3 rounded-full font-semibold shadow hover:bg-[#23242a]"
          >
            Blog
          </Link>
        </div>


      </nav>
    </>
  );
}
